import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=37b5ac81&scoped=true&"
import script from "./NotFoundView.vue?vue&type=script&lang=js&"
export * from "./NotFoundView.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=37b5ac81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b5ac81",
  null
  
)

export default component.exports